import Base from 'src/storage/base';
import moment from 'moment';

class ClinicSalesModel extends Base {
  id = 'ClinicSalesModel';
  defaultState = () => ({
    current: 'recent',
    pageIndex: 0,
    sortBy: {
      key: 'created',
      desc: true
    },
    endDate: moment(),
    tab: 'doctors'
  });
  refreshOnInit = false;
  refreshOnSubscribe = false;
}

const model = new ClinicSalesModel();
export default model;
